/*
 * @Author: Dong
 * @Date: 2022-04-07 13:40:11
 * @LastEditors: zhang lin
 * @LastEditTime: 2023-01-05 09:28:58
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  detail: '详情',
  config: '配置',
  nodeList: '节点列表',
  nodeName: '节点名称',
  memory: '内存',
  disk: '磁盘空间',
  tag: '标签',
  roleCOnfig: '角色配置',
  version: '版本',
  requiredNull: '请选择版本',
  requiredInput: '请输入',
  type: '安装方式',
});
